/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Guest_Picker_Child_LabelInputs */

const en_guest_picker_child_label = /** @type {(inputs: Guest_Picker_Child_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Child ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Child {index}" |
*
* @param {Guest_Picker_Child_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_child_label = /** @type {((inputs: Guest_Picker_Child_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Child_LabelInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_child_label(inputs)
});